module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }